import script from "./BaseTablePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTablePagination.vue?vue&type=script&setup=true&lang=js"

import "./BaseTablePagination.vue?vue&type=style&index=0&id=a724b4ba&lang=scss&scoped=true"
script.__scopeId = "data-v-a724b4ba"

export default script